import { useMediaQuery } from 'react-responsive';
import roiBreakpoints from '../../../../assets/stylesheets/components/series/the-rules-of-investing-components/_settings.global.scss';

export default function useTheme() {
  const isROIMobile = useMediaQuery({ query: `(max-width: ${roiBreakpoints.breakpointMobileMax})` });
  const isROIXSmall = useMediaQuery({ query: `(max-width: ${roiBreakpoints.breakpointXsmallMax})` });
  const isROISmall = useMediaQuery({ query: `(max-width: ${roiBreakpoints.breakpointSmallMax})` });
  const isROIMedium = useMediaQuery({ query: `(max-width: ${roiBreakpoints.breakpointMediumMax})` });
  const isROILarge = useMediaQuery({ query: `(max-width: ${roiBreakpoints.breakpointLargeMax})` });
  const isROIXLarge = useMediaQuery({ query: `(min-width: ${roiBreakpoints.breakpointXlargeMin})` });
  return {
    ...roiBreakpoints,
    isROIMobile,
    isROIXSmall,
    isROISmall,
    isROIMedium,
    isROILarge,
    isROIXLarge,
  };
}
